import React, { useEffect, useState } from "react";
/* COMPONENTS */
import { ListItemIcon, ListItemText, Alert, Menu, MenuItem, Snackbar, Typography, Chip } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { AddUser } from "components/dialog/users/AddUser";
import { EditUser } from "components/dialog/users/EditUser";
import { DeleteUser } from "components/dialog/users/DeleteUser";
import { ExtraPermission } from "components/dialog/users/ExtraPermission";
import { ExtraTag } from "components/dialog/users/ExtraTag";
/* ICONS */
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import CachedIcon from '@mui/icons-material/Cached';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import RuleIcon from '@mui/icons-material/Rule';
/* TRANSLATE */
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
/* REQUEST */
import { getUsers } from "utils/Users";
/* DAYSJS */
import dayjs from 'dayjs';
import { AssignReport } from "components/dialog/assign_report/AssignReport";
import { EnableOTP } from "components/dialog/users/EnableOTP";
import {
    buildUserManagementUsersActionPath,
    buildUserManagementUsersBasePath,
    parseUserManagementUsersRoute,
} from 'utils/userManagementUsersRouting';


const ContextMenu = ({ contextMenu, setContextMenu, selectedRow, reloading, rows, activate, setSelectedRow }) => {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()

    const [openAdd, setOpenAdd] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    //const [openInfo, setOpenInfo] = useState(false)
    const [openEnableOTP, setOpenEnableOTP] = useState(false)
    const [openExtraPermission, setOpenExtraPermission] = useState(false)
    const [openExtraTag, setOpenExtraTag] = useState(false)
    const [openExtraReport, setOpenExtraReport] = useState(false)
    const [openAlert, setOpenAlert] = useState(false)
    const [alert, setAlert] = useState({ msg: '', severity: '' })
    const [row, setRow] = useState(null)
    const loggedUsername = localStorage.getItem('username')
    const selectedUser = rows.find(row => row.id === selectedRow?.[0])
    const canEnableOtp = selectedRow?.length === 1 && selectedUser?.username === loggedUsername
    const routeAction = parseUserManagementUsersRoute(location.pathname)

    useEffect(() => {
        const action = routeAction.action

        if (!action) {
            setOpenAdd(false)
            setOpenEdit(false)
            setOpenDelete(false)
            setOpenEnableOTP(false)
            setOpenExtraPermission(false)
            setOpenExtraTag(false)
            setOpenExtraReport(false)
            return
        }

        if (routeAction.id && rows.length > 0) {
            const matched = rows.find((row) => String(row.id) === String(routeAction.id))
            if (matched) {
                setSelectedRow([matched.id])
                setRow(matched)
            }
        }

        setOpenAdd(action === 'add')
        setOpenEdit(action === 'edit' && selectedRow?.length === 1)
        setOpenExtraPermission(action === 'extra-permissions' && selectedRow?.length === 1)
        setOpenExtraTag(action === 'extra-tags' && selectedRow?.length === 1)
        setOpenExtraReport(action === 'assign-reports' && selectedRow?.length === 1)
        setOpenDelete(action === 'toggle-active' && selectedRow?.length === 1)
        setOpenEnableOTP(action === 'enable-otp' && canEnableOtp)
    }, [canEnableOtp, routeAction.action, routeAction.id, rows, selectedRow?.length, setSelectedRow])

    const closeToBase = () => {
        if (location.pathname !== buildUserManagementUsersBasePath()) {
            navigate(buildUserManagementUsersBasePath())
        }
    }

    const options = [
        {
            name: t('user_management.table.context_menu.add'),
            icon: <AddIcon />,
            click: () => {
                navigate(buildUserManagementUsersActionPath('add'))
                setContextMenu(null)
                },
            color: '',
            selected: false,
            onlyOne: false,
        },
        {
            name: t('user_management.table.context_menu.edit'),
            icon: <EditIcon />,
            click: () => {
                navigate(buildUserManagementUsersActionPath('edit', selectedRow?.[0]))
                setContextMenu(null)
            },
            color: '',
            disabled: selectedRow?.length !== 1 ? true : false
        },
        {
            name: t('user_management.table.context_menu.duplicate'),
            icon: <ContentCopyIcon />,
            click: async ()  => {
                //setOpenDuplicate(true)
                setContextMenu(null)
            },
            color: '',
            disabled: selectedRow?.length !== 1 ? true : false
        },
        {
            name: t('user_management.table.context_menu.extra_permission'),
            icon: <HowToRegIcon />,
            click: async ()  => {
                navigate(buildUserManagementUsersActionPath('extra-permissions', selectedRow?.[0]))
                setContextMenu(null)
                const row = rows.find(row => row.id === selectedRow[0])
                setRow(row)
            },
            color: '',
            disabled: selectedRow?.length !== 1 ? true : false
        },
        {
            name: t('user_management.table.context_menu.extra_tag'),
            icon: <RuleIcon />,
            click: async ()  => {
                navigate(buildUserManagementUsersActionPath('extra-tags', selectedRow?.[0]))
                setContextMenu(null)
            },
            color: '',
            disabled: selectedRow?.length !== 1 ? true : false
        },
        {
            name: t('Asignar reportes'),
            icon: <RuleIcon />,
            click: async ()  => {
                navigate(buildUserManagementUsersActionPath('assign-reports', selectedRow?.[0]))
                setContextMenu(null)
            },
            color: '',
            disabled: selectedRow?.length !== 1 ? true : false
        },
        {
            name: activate === 'Activo' ? t('user_management.table.context_menu.deactivate') : t('user_management.table.context_menu.activate'),
            icon: <DeleteIcon color='error'/>,
            click: () => {
                navigate(buildUserManagementUsersActionPath('toggle-active', selectedRow?.[0]))
                setContextMenu(null)
                const row = rows.find(row => row.id === selectedRow[0])
                setRow(row)
            },
            color: 'error',
            disabled: selectedRow?.length !== 1 ? true : false,
            selected: false,
            onlyOne: true,
        },
        {
            name: t('user_management.table.context_menu.info'),
            icon: <InfoIcon />,
            disabled: selectedRow?.length !== 1 ? true : false,
            click: () => {
                //setOpenInfo(true)
                setContextMenu(null)
            },
            color: ''
        },
        {
            name: t('user_management.table.context_menu.reload'),
            icon: <CachedIcon/>,
            color: '',
            click: () => {
                reloading()
                setContextMenu(null)
            }
        },
        {
            name: t('user_management.table.context_menu.enable_otp'),
            icon: <RuleIcon />,
            click: async ()  => {
                navigate(buildUserManagementUsersActionPath('enable-otp', selectedRow?.[0]))
                setContextMenu(null)
            },
            color: '',
            disabled: !canEnableOtp
        }

    ]

    return (
        <>
            <Menu
                open={contextMenu ? true : false }
                onClose={() => setContextMenu(null)}
                anchorReference="anchorPosition"
                anchorPosition={contextMenu ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined }
                sx={{boxShadow: 'none'}}
                slotProps={{
                    root: {
                        'aria-hidden': 'false'
                    }
                }}
            >
                { options.map((option, index) =>
                    <MenuItem key={index} onClick={option.click} disabled={option.disabled}>
                        <ListItemIcon>
                            { option.icon }
                        </ListItemIcon>

                        <ListItemText primary={option.name} primaryTypographyProps={{color: option.color}}/>
                    </MenuItem>
                )}
            </Menu>

            <AddUser open={openAdd} setOpen={(value) => { setOpenAdd(value); if (!value) { closeToBase(); } }} setAlert={setAlert}  setOpenAlert={setOpenAlert} setContextMenu={setContextMenu} reloading={reloading}/>
            <EditUser open={openEdit} setOpen={(value) => { setOpenEdit(value); if (!value) { closeToBase(); } }} setAlert={setAlert} setOpenAlert={setOpenAlert} setContextMenu={setContextMenu} reloading={reloading} selected={selectedRow}/>
            <DeleteUser open={openDelete} setOpen={(value) => { setOpenDelete(value); if (!value) { closeToBase(); } }} setAlert={setAlert} setOpenAlert={setOpenAlert} setContextMenu={setContextMenu} reloading={reloading} setSelectedRow={setSelectedRow} row={row}/>
            <ExtraPermission open={openExtraPermission} setOpen={(value) => { setOpenExtraPermission(value); if (!value) { closeToBase(); } }} setAlert={setAlert} setOpenAlert={setOpenAlert} setContextMenu={setContextMenu} reloading={reloading} selected={selectedRow} setSelectedRow={setSelectedRow} row={row}/>
            <ExtraTag open={openExtraTag} setOpen={(value) => { setOpenExtraTag(value); if (!value) { closeToBase(); } }} setAlert={setAlert} setOpenAlert={setOpenAlert} setContextMenu={setContextMenu} reloading={reloading} selected={selectedRow} setSelectedRow={setSelectedRow}/>
            <AssignReport open={openExtraReport} setOpen={(value) => { setOpenExtraReport(value); if (!value) { closeToBase(); } }} setAlert={setAlert} setOpenAlert={setOpenAlert} row={rows.find(row => row.id === selectedRow[0])}/>
            <EnableOTP open={openEnableOTP} setOpen={(value) => { setOpenEnableOTP(value); if (!value) { closeToBase(); } }} setAlert={setAlert} setOpenAlert={setOpenAlert} row={rows.find(row => row.id === selectedRow[0])} reloading={reloading} setSelectedRow={setSelectedRow}/>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={openAlert}
            >
                <Alert
                    onClose={() => setOpenAlert(false)}
                    severity= {alert.severity}
                    sx={{ width: '100%' }}
                >
                    {alert.msg}
                </Alert>
            </Snackbar>
        </>
    )
}

const UsersTable = () => {
    const { t } = useTranslation()

    const [loading, setLoading] = useState(true)
    const [rows, setRows] = useState([])
    const [contextMenu, setContextMenu]   = useState(null)
    const [selectedRow, setSelectedRow]   = useState([])
    const [activate, setActivate] = useState(null)

    const validateActiveStatus = (start, end) => {
        try {
            if (!start || !end) {
                return 'Desactivado';
            }

            const currentDate = dayjs();
            const startDate = dayjs(start);
            const endDate = dayjs(end);

            // Si la fecha end es igual a la fecha actual, está desactivado
            if (currentDate.isSame(endDate, 'day')) {
                return 'Desactivado';
            }

            // Si la fecha de inicio es futura
            if (currentDate.isBefore(startDate)) {
                return `Activo a partir de ${startDate.format('YYYY-MM-DD')}`;
            }

            // Si la fecha end es 3000-01-01 o si está dentro del rango de fechas
            if (
                (endDate.year() === 3000 && endDate.month() === 0 && endDate.date() === 1) ||
                ((currentDate.isAfter(startDate) || currentDate.isSame(startDate, 'day')) && currentDate.isBefore(endDate))
            ) {
                return 'Activo';
            }

            return 'Desactivado';

        } catch(error) {
            console.error('Error validating active status:', error.message);
            return 'Error';
        }
    };

    const columns = [
        {
            field: 'username',
            headerName: t('user_management.table.columns.username'),
            flex: 1,
        },
        {
            field: 'profile_name',
            headerName: t('user_management.table.columns.profile_name'),
            flex: 1,
            filterable: false
        },
        {
            field: 'owner_user',
            headerName: t('user_management.table.columns.owner_user'),
            flex: 1,
            align: 'center',
            filterable: false,
            renderCell: (params) => {

               return params.value ? (
                    <DoneIcon color="success"/>
                ) : (
                    <CloseIcon color="error"/>
                )

            }
        },
        {
            field: 'type',
            headerName: t('user_management.table.columns.type'),
            flex: 1,
            align: 'center',
            filterable: false,
            renderCell: (params) => {

               return params.value ? (
                    <Typography>{params.value}</Typography>
                ) : (
                    <CloseIcon color="error"/>
                )

            }
        },
        {
            field: 'enable',
            headerName: t('user_management.table.columns.enable'),
            flex: 1,
            align: 'center',
            filterable: false,
            renderCell: (params) => {

                const value = validateActiveStatus(params.value.start, params.value.end)

               if(value === 'Activo') {
                   return  (
                        <Chip label={value} icon={<DoneIcon color="success"/>} variant="outlined"/>
                   )
                } else if(value === 'Desactivado') {
                    return  (
                        <Chip label={value} icon={<CloseIcon color="error"/>} variant="outlined"/>
                    )
                } else {
                    return (
                        <Chip label={value} icon={<PriorityHighIcon color="warning"/>} variant="outlined"/>
                    )

                }

            }
        },
    ]

    const reloading = () => {
        getUsers(setLoading, setRows)
    }

    useEffect(() => {
        reloading(setLoading, setRows)
    }, [])

    return (
        <>
            <div
                style={{width: '100%', height: '100%', }}
                onContextMenu={(e) => {
                    e.preventDefault();
                    setContextMenu(contextMenu === null ? { mouseX: e.clientX - 2, mouseY: e.clientY - 4} : null)
                }}
            >
                <DataGridPro
                    columns={columns}
                    rows={rows}
                    initialState={{
                        sorting: {
                            sortModel: [{ field: 'username', sort: 'asc' }],
                        },
                    }}
                    showCellVerticalBorder
                    showColumnVerticalBorder
                    headerFilters
                    localeText={
                        {
                            headerFilterOperatorContains: t('general.table.headerFilters.headerFilterOperatorContains'),
                            headerFilterOperatorEquals: t('general.table.headerFilters.headerFilterOperatorEquals'),
                            headerFilterOperatorStartsWith: t('general.table.headerFilters.headerFilterOperatorStartsWith'),
                            headerFilterOperatorEndsWith: t('general.table.headerFilters.headerFilterOperatorEndsWith'),
                            headerFilterOperatorIsEmpty: t('general.table.headerFilters.headerFilterOperatorIsEmpty'),
                            headerFilterOperatorIsNotEmpty: t('general.table.headerFilters.headerFilterOperatorIsNotEmpty'),
                            footerRowSelected: (count) =>
                                count > 1
                                ? t('general.table.footerFilters.footerRowSelected.>1', {count: count.toLocaleString()})
                                : t('general.table.footerFilters.footerRowSelected.=1', {count: count.toLocaleString()}),

                            footerTotalRows: t('general.table.footerFilters.footerTotalRows'),
                            MuiTablePagination: {
                                labelDisplayedRows: ({ from, to, count }) =>
                                    t('general.table.footerFilters.labelDisplayedRows', {from: from.toLocaleString(), to: to.toLocaleString(), count: count.toLocaleString()}),
                                labelRowsPerPage: t('general.table.footerFilters.labelRowsPerPage'),},
                        }
                    }
                    disableColumnMenu
                    loading={loading}
                    checkboxSelection
                    onRowSelectionModelChange={(newRowSelectionModel) => {
                        setSelectedRow(newRowSelectionModel);
                        const row = rows.find(row => row.id === newRowSelectionModel[0])
                        setActivate(validateActiveStatus(row?.enable?.start, row?.enable?.end))

                    }}
                    rowSelectionModel={selectedRow}
                    pagination
                    sx={{
                        height: 'calc(100vh - 140px)',
                    }}
                />

            </div>
            <ContextMenu
                contextMenu={contextMenu}
                setContextMenu={setContextMenu}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
                reloading={reloading}
                rows={rows}
                activate={activate}
            />
        </>
    )
}

export { UsersTable }